import { computed, type Ref } from 'vue'

import { type JobStatus } from '@/constants/persoplan'
import scssVariables from '@/assets/scss/scssVariables'
import type { Nilable } from '@/types/misc'

export type { JobStatus } from '@/constants/persoplan'

interface Options {
  status: Ref<Nilable<JobStatus>>
}

const colors = {
  confirmed: scssVariables.color['status-job-confirmed'],
  requested: scssVariables.color['status-job-requested'],
  cancelled: scssVariables.color['status-job-cancelled'],
  considered: scssVariables.color['status-job-considered'],
  offered: scssVariables.color['status-job-offered'],
  service: scssVariables.color['status-job-service'],
  subHire: scssVariables.color['status-job-subHire'],
  itemTransfer: scssVariables.color['status-job-itemTransfer'],
} as const satisfies Record<JobStatus, string>

function getColor(status?: Nilable<JobStatus>) {
  if (!status) return

  return colors[status]
}

export function useJobStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusJob-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    return getColor(options.status.value)
  })

  return {
    id: options.status.value,
    classes,
    color,
  }
}

export { getColor as getJobColor }
